import { Link } from 'react-router-dom';
import { categories } from '@/mocks/home';

export default function CategorySection() {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <span className="inline-block px-4 py-1.5 rounded-full bg-primary-50 text-primary-700 text-xs font-medium mb-4">
            服务分类
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            探索你感兴趣的数字生活
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            六大核心板块，覆盖亚洲数字生活的每一个精彩角落
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {categories.map((cat) => (
            <Link
              key={cat.id}
              to={`/category/${cat.slug}`}
              className="group relative overflow-hidden rounded-xl bg-background-100 border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              <div className="aspect-[16/10] overflow-hidden">
                <img
                  src={cat.image}
                  alt={cat.name}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-5">
                <div className="flex items-center gap-3 mb-2">
                  <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-50 text-primary-600">
                    <i className={`${cat.icon} text-lg`}></i>
                  </div>
                  <h3 className="font-heading text-lg font-semibold text-foreground-900">
                    {cat.name}
                  </h3>
                </div>
                <p className="text-sm text-foreground-500 leading-relaxed">
                  {cat.description}
                </p>
                <div className="flex items-center gap-1 mt-3 text-sm text-primary-600 font-medium">
                  <span>浏览更多</span>
                  <i className="ri-arrow-right-line text-sm"></i>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}